import { ParseObservable } from './parse-observable';
import { Injectable } from '@angular/core';

import { Observable, Observer } from 'rxjs';
import { flatMap, map, publishReplay, refCount } from 'rxjs/operators';

import { EventCategory } from '../data';
import { EventCategoryQuery } from '../queries';

@Injectable()
export class EventCategoryService {
  private _find: Observable<EventCategory[]>;
  private _tree: Observable<EventCategory[]>;

  constructor() {

  }

  public get(id: string): Observable<EventCategory> {
    return this.tree().pipe(flatMap(parents => {
      let category;

      parents.forEach(p => {
        if (p.id == id) {
          category = p;
        } else {
          let children = <EventCategory[]> p['children'];

          if (children) {
            let find = children.find(c => c.id == id);

            if (find) {
              category = find;
            }
          }
        }
      })

      return Observable.of(category);
    }))
  }

  public find() {
    if (!this._find) {
      let query = new EventCategoryQuery()
          .include(EventCategory.PARENT_KEY)
          .include(EventCategory.IMAGE_KEY)
          .equalTo(EventCategory.ENABLED_KEY, true)
          .ascending(EventCategory.SORT_ORDER_KEY);

      this._find = query.rx().find().publishReplay(1).refCount();
    }
    return this._find;
  }

  public tree() {
    if (!this._tree) {
      this._tree = this.find().pipe(map<EventCategory[], EventCategory[]>(arr => {
        return arr.filter(c => !c.parent).map(c => {
          c['children'] = arr.filter(o => o.parent && o.parent.id === c.id);
          return c;
        });
      })).pipe(publishReplay(1)).pipe(refCount())

    }
    return this._tree;
  }
}
